/* KRAVOS V26 — delegated full-card navigation + collection inline fallback */
(function () {
  if (window.__kravosCardClickBound) return;
  window.__kravosCardClickBound = true;

  function isInteractive(target) {
    return target.closest(
      'a, button, input, select, textarea, summary, label, [role="button"], [role="link"], modal-opener, quick-add-modal, product-form, quantity-popover, .quick-add, .quick-add-bulk'
    );
  }

  function goToCardProduct(card) {
    if (!card || !card.dataset.krProductUrl) return;
    window.location.href = card.dataset.krProductUrl;
  }

  // Capture-phase handler is intentional: some Shopify/theme media elements
  // stop bubbling before the normal document click handler can see the event.
  // This makes the entire product card (including the image area) clickable.
  document.addEventListener('click', function (event) {
    var card = event.target.closest('.kr-card-clickable[data-kr-product-url]');
    if (!card || isInteractive(event.target)) return;
    goToCardProduct(card);
  }, true);

  // Keep a card-level fallback for themes/custom elements that alter event flow.
  document.querySelectorAll('.kr-card-clickable[data-kr-product-url]').forEach(function (card) {
    if (card.__kravosCardClickBound) return;
    card.__kravosCardClickBound = true;
    card.addEventListener('click', function (event) {
      if (isInteractive(event.target)) return;
      goToCardProduct(card);
    });
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    var card = event.target.closest('.kr-card-clickable[data-kr-product-url]');
    if (!card || isInteractive(event.target)) return;
    event.preventDefault();
    goToCardProduct(card);
  });
})();
